import { Component, Vue } from 'vue-property-decorator'
import { api } from '../../api'
import { UNPROCESSABLE_ENTITY } from 'http-status-codes'
import { validPassword } from '@/galaxy-cruise/utils/validation'
import { store } from '@/store'
import { loginGuard } from '@/galaxy-cruise/utils'

@Component
export default class extends Vue {
  static beforeEnter = loginGuard

  password = ''
  passwordAgain = ''
  validateAlways = false

  focus() {
    (this.$refs.password as HTMLInputElement).focus()
  }

  async submit() {
    if (!this.ok) {
      (this.$refs.dialog as any).shake(() => this.validateAlways = true)
      return
    }

    const axios = api.passErrors(UNPROCESSABLE_ENTITY)
    const new_password = this.password
    await axios.post('../api/v1/password_reset/new_password', {
      new_password,
    })
    alert(this.$t('saved'))
    this.$router.push('/')
  }

  get passwordErrors() {
    return [!validPassword(this.password) && this.$t('must_be_length_of_at_least_8')].filter((e) => e)
  }

  get passwordAgainErrors() {
    return [this.password !== this.passwordAgain && this.$t('do_not_match')].filter((e) => e)
  }

  get ok() {
    return this.passwordErrors.length + this.passwordAgainErrors.length === 0
  }

  get updatePassword() {
    return store.galaxyCruise.session!.user.password_is_set
  }

  get email() {
    return store.galaxyCruise.session!.user.email
  }
}
